function addHoverEffectToHeader() {
    const headerTransparentElements = document.querySelectorAll('.header-transparent');
    const menuParentElements = document.querySelectorAll('.bls__menu-parent');
  
    menuParentElements.forEach((menuParentElement) => {
        menuParentElement.addEventListener('mouseover', () => {
            headerTransparentElements.forEach((headerTransparentElement) => {
                headerTransparentElement.classList.add('hoverAc');
            });
        });
  
        menuParentElement.addEventListener('mouseout', () => {
            headerTransparentElements.forEach((headerTransparentElement) => {
                headerTransparentElement.classList.remove('hoverAc');
            });
        });
    });
  }
  
  function addCheckboxFunctionality() {
    const bojoCheckbox = document.getElementById("bojo");
  
    function updateCheckboxValue() {
        const value = bojoCheckbox.checked ? "Sim" : "Não";
        bojoCheckbox.setAttribute("value", value);
    }
  
    if (bojoCheckbox) {
        updateCheckboxValue();
        bojoCheckbox.addEventListener("change", updateCheckboxValue);
    }
  }
  
  document.addEventListener("DOMContentLoaded", function () {
    addHoverEffectToHeader();
    addCheckboxFunctionality();
  });
  
    // Função para verificar se o parâmetro já existe na URL
    function isAvailabilityParamPresent(url) {
      var regex = /(\?|&)filter\.v\.availability=1(&|$)/;
      return regex.test(url);
    }
  
    // Função para adicionar o parâmetro à URL
    function addAvailabilityToURL(url) {
      // Verifica se o parâmetro já está presente na URL
      if (!isAvailabilityParamPresent(url)) {
        // Adiciona o parâmetro à URL
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'filter.v.availability=1';
      }
      return url;
    }
  
    // Função para manipular a URL quando um filtro é clicado
    function handleFilterClick(event) {
      event.preventDefault();
      var filterLink = event.currentTarget;
      var urlToModify = filterLink.getAttribute('href');
  
      // Verifica se o parâmetro já está presente na URL
      if (!isAvailabilityParamPresent(urlToModify)) {
        // Adiciona o parâmetro à URL
        var modifiedURL = addAvailabilityToURL(urlToModify);
  
        // Redireciona para a URL modificada
        window.location.href = modifiedURL;
      }
    }
  
    // Adiciona um ouvinte de evento a todos os links de filtro
    document.addEventListener('DOMContentLoaded', function () {
      var filterLinks = document.querySelectorAll('.bls__link-filter');
      filterLinks.forEach(function (link) {
        link.addEventListener('click', handleFilterClick);
      });
    });

    document.addEventListener("DOMContentLoaded", () => {
      const menuItems = document.querySelectorAll(".menu li a span");
    
      menuItems.forEach(link => {
        link.setAttribute("data-text", link.textContent);
        if (/black\s?friday/i.test(link.textContent)) {
          link.classList.add("animation-black-friday");
        }
      });
    });
    
    document.addEventListener("DOMContentLoaded", function() {
      function checkProductAvailability() {
          if (typeof product !== 'undefined' && product.selected_or_first_available_variant) {
              const isAvailable = product.selected_or_first_available_variant.available;
              const alertDiv = document.getElementById("cheguei-alert-div");
              if (alertDiv) {
                  alertDiv.style.display = isAvailable ? "block" : "none";
              }
          }
      }
  
      checkProductAvailability();
  
      const variantSelector = document.querySelector("[name='id']");
      if (variantSelector) {
          variantSelector.addEventListener("change", function() {
              checkProductAvailability();
          });
      }
  });